module.exports = __webpack_public_path__ + "static/media/excell_icon.a68a3c3f.svg";